"use client";

import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import styles from "@@/styles/components/shared/ColorBackground.module.scss";

gsap.registerPlugin(ScrollTrigger);

interface ColorBackgroundProps {
    colorsMap: { selector: string; color: string; offset?: number; startBefore?: number}[];
}

export default function ColorBackground({ colorsMap }: ColorBackgroundProps) {
    const bgRef = useRef<HTMLSpanElement>(null);

    useEffect(() => {
        const bg = bgRef.current;
        if (!bg) return;

        colorsMap.forEach(({ selector, color, offset, startBefore }) => {
            const section = document.querySelector(selector);
            if (section) {
                ScrollTrigger.create({
                    trigger: section,
                    start: `top+=${startBefore ?? 0} center`,
                    end: `bottom+=${200 + (offset ?? 0)} center`,
                    onEnter: () => {
                        gsap.to(bg, { background: color, duration: .5 });
                    },
                    onEnterBack: () => {
                        gsap.to(bg, { background: color, duration: .5 });
                    },
                });
            }
        });

        return () => ScrollTrigger.getAll().forEach(t => t.kill());
    }, [colorsMap]);

    return <span ref={bgRef} className={styles.bg} aria-hidden={true}/>;
}
